module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG094c8a0b91b09f5dbfbdab89afc886fe.094c8a0b.png";